module.exports = __webpack_public_path__ + "2016-10-16_2048_large.png?d4e0f65849e36b9827f205828de3b060";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2016-10-16_2048_large.png
// module id = 661
// module chunks = 0